import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component EditMultipleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <EditMultipleIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <EditMultipleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const EditMultipleIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="EditMultipleIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m17.83 11 1.41 1.41-7.125 7.125a.997.997 0 0 1-1.493-1.316l.083-.094zM10 13a1 1 0 0 1 .117 1.993L10 15H4a1 1 0 0 1-.117-1.993L4 13zm10.83-5 1.41 1.41-1.83 1.83L19 9.83zM14 9a1 1 0 0 1 .117 1.993L14 11H4a1 1 0 0 1-.117-1.993L4 9zm3-4a1 1 0 0 1 .117 1.993L17 7H4a1 1 0 0 1-.117-1.993L4 5z"
      />
    </svg>
  )
);
EditMultipleIcon.displayName = "EditMultipleIcon";
export default EditMultipleIcon;
